/*
NEXT STEPS:

- if user selects NO extra pack:
  - if the are all NO:
    - change PAGINATION to show regular pagination in the summary page
    - disable and hide fields for the children that do not have the extra pack 
    
- child-name not being added for treats

- improve summary

- capitalise first letter names, friend names and city names

- after changing slide, focus on first field

EXTRA:
- save JSON data in storage when clicking Next
- should we render each slide based on JSON data from a cookie, and save it on each step?
- that would mean when changing children or changing names, then clicking next, we would save the data, then re-render the whole stuff based on that data


[OK]- close popup button removes hash
[OK]- if questionnaire without hash, close the popup and go to slide 1
- when press forward in the browser, we need to validate again wtf

*/

(function(){  
  
  const radioButtons = document.querySelectorAll('[name="slider"]')
  const plButtons = document.querySelectorAll('.start-letter')
  const plModal = document.querySelector('#personalised-letter')
  const plClose = document.querySelectorAll('.pl-close')
  const pageBody = document.querySelector('body')
  const modalMessage = document.querySelector("#modal-message")
  const modalMessageClose = modalMessage.querySelector('.modal-message__close')
  const modalMessageText = modalMessage.querySelector('.modal-message__text')

  modalMessageClose.addEventListener('click', () => {
    modalMessage.close()
  })

  function handleBeforeUnload(e){
    e.preventDefault();
    return e.returnValue = "";
  }

  function handlePopstate(){
    return "Are you sure you want to leave? All provided data will be lost.";
  }

  /* Fields */
  const numberOfChildrenField = plModal.querySelector('[data-number-children]')
  const slides = plModal.querySelectorAll('.xmas-slide:not(.xmas-slide-1):not(.xmas-slide-14)')
  const childrenNames = []
  const addButton = plModal.querySelector('[data-add-all]')
  
    
  /* Show or close modal */
  plButtons.forEach(plButton => {   
  
    plButton.addEventListener('click', () => {
      plModal.querySelector('label[for="xmas-radio-1"]').click()
      plModal.classList.add('show')
      pageBody.classList.add('noscroll')
      
      let changeEvent = new Event('change')
      document.querySelector('#xmas-radio-1').dispatchEvent(changeEvent)
  
      saveToHistory("q1")
      
      //window.addEventListener('beforeunload', handleBeforeUnload, true);
      
    })
  })
  plClose.forEach( closeButton => {
    closeButton.addEventListener('click', () => {
      plModal.classList.remove('show')
      pageBody.classList.remove('noscroll')

      //window.removeEventListener('beforeunload', handleBeforeUnload, true);
      window.location.hash = ''
      
    })
    
  })
   

  numberOfChildrenField.addEventListener('change', () => {
    const numberOfChildren = numberOfChildrenField.value
    
    slides.forEach( slide => {
          
      const fieldSets = slide.querySelectorAll('.xmas-field-set')
      const pageControls = slide.querySelector('.xmas-control')
      const fieldsTemplate = slide.querySelector('.xmas-template')
      
      if( fieldSets.length < numberOfChildren ){
        //duplicate the xmas-template (fields.length - numberOfChildren) times        
        for(i=fieldSets.length; i < numberOfChildren; i++){
          let clonedTemplate = fieldsTemplate.innerHTML
          clonedTemplate = clonedTemplate.replaceAll('[child-count]',(i+1).toString());
          fieldsTemplate.insertAdjacentHTML("beforebegin", clonedTemplate)
        }
        listenChildrenNames()
        listenAddOns()
        listenAges()
        listenTreats()
        listenAllFields()
        return;
      }
      if( fieldSets.length > numberOfChildren ){
        //Reducing children: remove the last (numberOfChildren - fieldSets.length) occurrences of the xmas-field-set in each slide
        for(i=fieldSets.length - 1; i >= numberOfChildren; i--){
          fieldSets[i].remove()
        }        
        return
      }           
    })
    let changeEvent = new Event('change')
    document.querySelector('#xmas-radio-1').dispatchEvent(changeEvent)
  })

  function listenChildrenNames(){
    const nameFields = document.querySelectorAll('[data-first-name]')
    //console.log(nameFields)
    nameFields.forEach( nameField => {
      nameField.addEventListener('change', () => {
        saveChildrenNames()
        replaceChildrenNames()
      })
    })
  }

  function listenAllFields(){
    const allFields = plModal.querySelectorAll('select, input')

    allFields.forEach( inputField => {
      inputField.addEventListener('focus', () => {
        inputField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      })
    })  

  }

  function saveChildrenNames(){
    const nameFields = document.querySelectorAll('[data-first-name]')
    childrenNames.splice(0)
    nameFields.forEach( nameField => {
      childrenNames.push(nameField.value.trim())
    })
  }

  function replaceChildrenNames(){
    const nameFields = document.querySelectorAll('[data-first-name]')
    if(childrenNames.length <= 0) return
    slides.forEach( slide => {
      slide.querySelectorAll('label:not([for*="xmas-radio"]')?.forEach( (label,index) => {
        //console.log(label, label.textContent, childrenNames[index], "XXX")
        if(label.querySelector('.child-name') && childrenNames[index]){
          label.querySelector('.child-name').textContent = childrenNames[index]
        }
      })
    })
  }

  function listenAges(){
    const ages = document.querySelectorAll('select[data-label="Age"]')
    ages.forEach (age => {
      age.addEventListener('change', () => {
        const monthsSelect = age.nextElementSibling
        if(age.value == "0"){  
          monthsSelect.style.display = 'inline-block';
          monthsSelect.removeAttribute('disabled')
        }
        if(age.value != "0"){
          monthsSelect.style.display = 'none'
          monthsSelect.disabled = "disabled"
        }
      })    
    })
                              
  }

  function listenTreats(){
    const treatsSlider = document.querySelector('.xmas-slide.xmas-slide-7')
    const treatsSets = treatsSlider?.querySelectorAll('.xmas-field-set')
    
    treatsSets.forEach(treatsSet => {  
      const treatsInputs = treatsSet.querySelectorAll('input[name="treat"]')
      treatsInputs.forEach( treatsInput => {
        treatsInput.addEventListener('change', (e) => {
          var count = 0;
          treatsInputs.forEach( ti => {if(ti.checked) count++})
          if(count > 2) {
            e.target.checked = false;              
            showModalMessage("Select up to 2 treats for Santa per child.")
          }
        })
      })
    })
  }

  function capitaliseFirstLetter(string){
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  function saveToHistory(hash) {
    const currentURL = window.location.href
    let updatedURL = ""
    if (currentURL.indexOf('#') === -1) {
      updatedURL = currentURL + "#" + hash; // Add the hash
    } else {
      updatedURL = currentURL.replace(/#.*/, "#" + hash); 
    }     
  
    history.pushState(null, null, updatedURL);
    console.log('Page saved to history:', updatedURL);
  }

  // Function to retrieve the latest page from the browser's history
  function retrieveFromHistory() {
    history.back();
    console.log('Retrieved latest page from history');
  }

  window.addEventListener('popstate', function(event) {
    console.log('User navigated back to a previous state');
    const currentURL = window.location.href
    if(currentURL.indexOf('#') === -1) return;

    var hash = window.location.hash.substring(1);
    if(hash){
      let hashNumber = hash.replace('q',"")
      if(hashNumber){
        const slideToGo = document.querySelector('#xmas-radio-' + hashNumber)
        if(slideToGo) slideToGo.click()
        return
      }
    }
    plClose[0].click()
  });

  if (performance.navigation.type === PerformanceNavigation.TYPE_RELOAD) {
    console.log('Page was reloaded');
    //check if there is a hash. if there is, remove it
  } else if (performance.navigation.type === PerformanceNavigation.TYPE_NAVIGATE) {
    console.log('User landed on the page');
    //check if there is a hash. if there is, remove it
  }


  function getItemsCart(){
    const mainProduct = document.querySelector('#main-product').value
    const numberOfChildren = numberOfChildrenField.value
    const items = []
    
    for(i=1; i <= numberOfChildren; i++){
      const childProperties = document.querySelectorAll('[data-child="' + i + '"]:not(input[type="checkbox"]):not([data-age-months])')
      let properties = {};
      
      childProperties.forEach(childProperty => {
        if(childProperty.value && childProperty.dataset.label) {
          if(childProperty.dataset.label == "Age" && childProperty.value == "0"){
            const ageMonths = document.querySelector('[data-child="' + i + '"][data-age-months]')
            properties[childProperty.dataset.label] = ageMonths.value
          } else {
            properties[childProperty.dataset.label] = childProperty.value
          }
        }
        //Excitement pack upgrade with its properties from the 4 extra questions
        if( childProperty.hasAttribute('data-addon') && childProperty.value == "Yes"){
          let addonProperties = {};
          addonProperties["Includes"] = "Official Nice List 2025 Badge • Official North Pole Coin in luxury satin pouch • Thank you card from Santa";
          addonProperties["Child Name"] = capitaliseFirstLetter(childrenNames[i-1])
          
          const addOnPropertyFields = document.querySelectorAll('[data-child="' + i + '"][data-addonq]:not([disabled])')
          addOnPropertyFields.forEach( addOnPropertyField => {
            if(addOnPropertyField.value){
              //addonProperties[addOnPropertyField.dataset.label] = addOnPropertyField.value
            }
          })
          
          let addon = {
            id: childProperty.dataset.addon,
            quantity: 1,
            properties: addonProperties
          }
          items.push(addon)
        }
      })

      const selectedTreats = [];
      const treatCheckboxes = document.querySelectorAll('[name="treat"][data-child="' + i + '"]');
      treatCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
          selectedTreats.push(checkbox.value.toLowerCase());
        }
      });
      if(selectedTreats.length > 0) 
        properties["Treats"] = selectedTreats.join(" and ")
      
      let item = {
        id: mainProduct,
        quantity: 1,
        properties: properties
      }
      items.push(item)
    }
    return items
  }

  function getItemsSummary(){
    const mainProduct = document.querySelector('#main-product').value
    const numberOfChildren = numberOfChildrenField.value
    const items = []
    
    for(i=1; i <= numberOfChildren; i++){
      const childProperties = document.querySelectorAll('[data-child="' + i + '"]:not(input[type="checkbox"]):not([disabled])')
      let properties = {};
      
      childProperties.forEach(childProperty => {
        if(childProperty.value && childProperty.dataset.label) {
          if(childProperty.dataset.label == "Age" && childProperty.value == "0"){
            const ageMonths = document.querySelector('[data-child="' + i + '"][data-age-months]')
            properties[childProperty.dataset.label] = ageMonths.value
          } else {
            properties[childProperty.dataset.label] = childProperty.value
          }
        }
        
      })

      const selectedTreats = [];
      const treatCheckboxes = document.querySelectorAll('[name="treat"][data-child="' + i + '"]');
      treatCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
          selectedTreats.push(checkbox.value);
        }
      });
      properties["Treats"] = selectedTreats.join(", ")
      
      let item = {
        properties: properties
      }
      items.push(item)
    }
    return items
  }

  const prevButtons = document.querySelectorAll('.xmas-prev')
  prevButtons.forEach( prevButton => {
    prevButton.addEventListener('click', (e) => {
      retrieveFromHistory()  
    })    
  })
  

  const nextButtons = document.querySelectorAll('.xmas-next')
  const summaryContainer = document.querySelector('#summary-container')
  nextButtons.forEach( nextButton => {
    nextButton.addEventListener('click', (e) => {
      //get the items
      const items = getItemsSummary()
      
      // Recursive function to handle nested properties
      function formatProperties(properties) {
        return Object.entries(properties)
          .map(([key, value]) => {
            if (typeof value === "object") {
              return `${formatProperties(value)}`;
            } else {
              return `<li><strong>${key}:</strong> ${value}</li>`;
            }
          })
          .join("");
      }
  
      // Define a template for the item summary
      const itemTemplate = item => `
        <div class="item-summary">
          <ul>${formatProperties(item)}</ul>
        </div>
      `;

      summaryContainer.innerHTML = "";
      items.forEach(item => {
        const itemSummary = document.createElement("div");
        itemSummary.innerHTML = itemTemplate(item);        
        summaryContainer.appendChild(itemSummary);
      });
    })
  })

  function listenAddOns(){
    const extraPacks = document.querySelectorAll("select[data-addon]")
    //the code below could be made nicer, but hey, this is so much easier to read...
    const nextSlide10 = document.querySelector('.xmas-slide-10')
    const nextSlide11 = document.querySelector('.xmas-slide-11')
    const nextSlide12 = document.querySelector('.xmas-slide-12')
    const nextSlide13 = document.querySelector('.xmas-slide-13')
    const nextSlides = [nextSlide10, nextSlide11, nextSlide12, nextSlide13]
    
    extraPacks.forEach( extraPack => {
      extraPack.addEventListener('change', (e) => {
        console.log("extraPack.value",extraPack.value)
        const childNumber = extraPack.dataset.child
        if(extraPack.value == "No"){
          console.log("childNumber",childNumber)
          nextSlides.forEach( slide => {
            const fields = slide.querySelectorAll('[data-child="'+childNumber+'"]')
            console.log("slide",slide, "fields", fields)
            fields.forEach( field => {
              //field.disabled = "disabled"
              //field.style.display = "none"
              //field.previousElementSibling.style.display = "none" //hide the label
            })
          })
        }
        if(extraPack.value == "Yes"){          
          console.log("childNumber",childNumber)
          nextSlides.forEach( slide => {
            const fields = slide.querySelectorAll('[data-child="'+childNumber+'"]')
            console.log("slide",slide, "fields", fields)
            fields.forEach( field => {
              field.removeAttribute("disabled")
              field.style.display = "inline-block"
              field.previousElementSibling.style.display = "inline-block" //show the label
            })
          })
        }
        var hasYes = false  
        extraPacks.forEach( pack => {
          if(pack.value == "Yes") hasYes = true
        })
        const nextButton = document.querySelector('.xmas-next[data-next-addon]')
        const summaryPrevButton = document.querySelector('.xmas-prev[data-prev-summary]')
        if(!hasYes){
          nextSlides.forEach( slide => {
            console.log("slide",slide)
            //slide.style.display = "none"
          })
          nextButton.setAttribute("for","xmas-radio-14")
          summaryPrevButton.setAttribute("for","xmas-radio-9")
        }
        if(hasYes){
          nextSlides.forEach( slide => {
            console.log("slide",slide)
            //slide.style.display = "flex"
          })      
          nextButton.setAttribute("for","xmas-radio-10")
          summaryPrevButton.setAttribute("for","xmas-radio-13")
        }
      })
      
    })
  }

  function showModalMessage(errorMessage){
    modalMessageText.innerHTML = errorMessage
    modalMessage.showModal()
    return
  }
  /*
  Validations:
  [OK]- step 1: no need
  [OK]- step 2: No empty fields. if 2 names added in one field detected by a space? Then double barrelled names with a ‘-’ can be added.
  [OK]- step 3: no need
  [OK]- step 4: no empty fields
  [OK]- step 5: no empty fields
  [OK]- step 6: no empty dropdowns
  [OK]- step 7: checkboxes min 1, max 2
  [OK]- step 8: no empty dropdown
  [OK]- step 9: no need
  [OK]- step 10: no empty input text (if enabled)
  [OK]- step 11: no empty dropdowns (if enabled)
  [OK]- step 12: no empty dropdowns (if enabled)
  [OK]- step 13: no empty dropdowns (if enabled)
  */

  const step1Next = document.querySelector('.xmas-next[for="xmas-radio-2"]')
  step1Next.addEventListener('click', (e) => {
    saveToHistory("q2")
  })
  

  //step 2: No empty fields. if 2 names added in one field detected by a space? Then double barrelled names with a ‘-’ can be added.
  const step2Next = document.querySelector('.xmas-next[for="xmas-radio-3"]')
  const step3radio =  document.querySelector('#xmas-radio-3') 
  step2Next.addEventListener('click', (e) => {
    e.preventDefault()

    let valid = true
    const step2Form = step2Next.closest('.xmas-form')
    const nameFields = step2Form.querySelectorAll('input')
    nameFields.forEach( nameField => {
      nameField.classList.remove('xmas-error')
        
      if(!nameField.value.trim() || nameField.value.trim().includes(" ")){
        nameField.classList.add('xmas-error')
        valid = false
      }
    })
    
    if(valid) {
      saveToHistory("q3")
      step3radio.checked = true;
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      step3radio.dispatchEvent(clickEvent);
      const changeEvent = new Event('change')
      step3radio.dispatchEvent(changeEvent)
      return true;
    }
    
    showModalMessage("Please fill in all name fields without space.")
    return false;
  })

  const step3Next = document.querySelector('.xmas-next[for="xmas-radio-4"]')
  step3Next.addEventListener('click', (e) => {
    saveToHistory("q4")
  })

  //step 4: No empty fields. No other restrictions
  const step4Next = document.querySelector('.xmas-next[for="xmas-radio-5"]')
  const step5radio =  document.querySelector('#xmas-radio-5')
  step4Next.addEventListener('click', (e) => {
    e.preventDefault()

    let valid = true
    const step4Form = step4Next.closest('.xmas-form')
    const inputFields = step4Form.querySelectorAll('input')
    inputFields.forEach( inputField => {
      inputField.classList.remove('xmas-error')
        
      if(!inputField.value){
        inputField.classList.add('xmas-error')
        valid = false
      }
    })
    
    if(valid) {
      saveToHistory("q5")
      step5radio.checked = true;
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      step5radio.dispatchEvent(clickEvent);
      const changeEvent = new Event('change')
      step5radio.dispatchEvent(changeEvent)
      return true;
    }
    
    showModalMessage("Please fill in all fields.")
    return false;
  })

  //step 5: No empty fields. No other restrictions
  const step5Next = document.querySelector('.xmas-next[for="xmas-radio-6"]')
  const step6radio =  document.querySelector('#xmas-radio-6') 
  step5Next.addEventListener('click', (e) => {
    e.preventDefault()

    let valid = true
    const step5Form = step5Next.closest('.xmas-form')
    const inputFields = step5Form.querySelectorAll('input')
    inputFields.forEach( inputField => {
      inputField.classList.remove('xmas-error')
        
      if(!inputField.value || inputField.value.includes(" ")){
        inputField.classList.add('xmas-error')
        valid = false
      }
    })
    
    if(valid) {
      saveToHistory("q6")
      step6radio.checked = true;
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      step6radio.dispatchEvent(clickEvent);
      const changeEvent = new Event('change')
      step6radio.dispatchEvent(changeEvent)
      return true;
    }
    
    showModalMessage("Please fill in all name fields without space.")
    return false;
  })

  //step 6: No empty dropdowns. No other restrictions
  const step6Next = document.querySelector('.xmas-next[for="xmas-radio-7"]')
  const step7radio =  document.querySelector('#xmas-radio-7') 
  step6Next.addEventListener('click', (e) => {
    e.preventDefault()

    let valid = true
    const step6Form = step6Next.closest('.xmas-form')
    const inputFields = step6Form.querySelectorAll('select')
    inputFields.forEach( inputField => {
      inputField.classList.remove('xmas-error')
        
      if(!inputField.value){
        inputField.classList.add('xmas-error')
        valid = false
      }
    })
    
    if(valid) {
      saveToHistory("q7")
      step7radio.checked = true;
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      step7radio.dispatchEvent(clickEvent);
      const changeEvent = new Event('change')
      step7radio.dispatchEvent(changeEvent)
      return true;
    }
    
    showModalMessage("Please select an option for each child.")
    return false;
  })

  //step 7: Checkboxes: min 1, max 2. No other restrictions
  const step7Next = document.querySelector('.xmas-next[for="xmas-radio-8"]')
  const step8radio =  document.querySelector('#xmas-radio-8')
  step7Next.addEventListener('click', (e) => {
    e.preventDefault()

    let valid = true
    const step7Form = step7Next.closest('.xmas-form')
    const fieldsets = step7Form.querySelectorAll('.xmas-field-set')
    
    fieldsets.forEach( fieldset => {
      fieldset.classList.remove('xmas-error')
      let checkedCount = 0;
      const inputFields = fieldset.querySelectorAll('input[type="checkbox"]')
      inputFields.forEach( inputField => {
        if(inputField.checked) checkedCount++;
      })
      if(checkedCount < 1 || checkedCount > 2){
        fieldset.classList.add('xmas-error')
        valid = false
      }
    })
      
    if(valid) {
      saveToHistory("q8")
      step8radio.checked = true;
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      step8radio.dispatchEvent(clickEvent);
      const changeEvent = new Event('change')
      step8radio.dispatchEvent(changeEvent)
      return true;
    }
    
    showModalMessage("Please select up to 2 treats per child.")
    return false;
  })
  
  //step 8: No empty dropdowns. No other restrictions
  const step8Next = document.querySelector('.xmas-next[for="xmas-radio-9"]')
  const step9radio =  document.querySelector('#xmas-radio-9') 
  step8Next.addEventListener('click', (e) => {
    e.preventDefault()

    let valid = true
    const step8Form = step8Next.closest('.xmas-form')
    const inputFields = step8Form.querySelectorAll('select')
    inputFields.forEach( inputField => {
      inputField.classList.remove('xmas-error')
        
      if(!inputField.value){
        inputField.classList.add('xmas-error')
        valid = false
      }
    })
    
    if(valid) {
      saveToHistory("q9")
      step9radio.checked = true;
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      step9radio.dispatchEvent(clickEvent);
      const changeEvent = new Event('change')
      step9radio.dispatchEvent(changeEvent)
      return true;
    }
    
    showModalMessage("Please select an option for each child.")
    return false;
  })

  const step9Next = document.querySelector('.xmas-next[for="xmas-radio-10"]')
  step9Next.addEventListener('click', (e) => {
    saveToHistory("q10")
  })
  
  //step 10: No empty fields. No other restrictions
  const step10Next = document.querySelector('.xmas-next[for="xmas-radio-11"]')
  const step11radio =  document.querySelector('#xmas-radio-11') 
  step10Next.addEventListener('click', (e) => {
    e.preventDefault()

    let valid = true
    const step10Form = step10Next.closest('.xmas-form')
    const inputFields = step10Form.querySelectorAll('input:not([disabled])')
    inputFields.forEach( inputField => {
      inputField.classList.remove('xmas-error')
        
      if(!inputField.value){
        inputField.classList.add('xmas-error')
        valid = false
      }
    })
    
    if(valid) {
      saveToHistory("q11")
      step11radio.checked = true;
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      step11radio.dispatchEvent(clickEvent);
      const changeEvent = new Event('change')
      step11radio.dispatchEvent(changeEvent)
      return true;
    }
    
    showModalMessage("Please fill in all fields.")
    return false;
  })

  //step 11: No empty dropdowns. No other restrictions
  const step11Next = document.querySelector('.xmas-next[for="xmas-radio-12"]')
  const step12radio =  document.querySelector('#xmas-radio-12') 
  step11Next.addEventListener('click', (e) => {
    e.preventDefault()

    let valid = true
    const step11Form = step11Next.closest('.xmas-form')
    const inputFields = step11Form.querySelectorAll('select:not([disabled])')
    inputFields.forEach( inputField => {
      inputField.classList.remove('xmas-error')
        
      if(!inputField.value){
        inputField.classList.add('xmas-error')
        valid = false
      }
    })
    
    if(valid) {
      saveToHistory("q12")
      step12radio.checked = true;
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      step12radio.dispatchEvent(clickEvent);
      const changeEvent = new Event('change')
      step12radio.dispatchEvent(changeEvent)
      return true;
    }
    
    showModalMessage("Please select an option for each child.")
    return false;
  })

  //step 12: No empty dropdowns. No other restrictions
  const step12Next = document.querySelector('.xmas-next[for="xmas-radio-13"]')
  const step13radio =  document.querySelector('#xmas-radio-13') 
  step12Next.addEventListener('click', (e) => {
    e.preventDefault()

    let valid = true
    const step12Form = step12Next.closest('.xmas-form')
    const inputFields = step12Form.querySelectorAll('select:not([disabled])')
    inputFields.forEach( inputField => {
      inputField.classList.remove('xmas-error')
        
      if(!inputField.value){
        inputField.classList.add('xmas-error')
        valid = false
      }
    })
    
    if(valid) {
      saveToHistory("q13")
      step13radio.checked = true;
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      step13radio.dispatchEvent(clickEvent);
      const changeEvent = new Event('change')
      step13radio.dispatchEvent(changeEvent)
      return true;
    }
    
    showModalMessage("Please select an option for each child.")
    return false;
  })

  //step 13: No empty dropdowns. No other restrictions
  const step13Next = document.querySelector('.xmas-next[for="xmas-radio-14"]')
  const step14radio =  document.querySelector('#xmas-radio-14') 
  step13Next.addEventListener('click', (e) => {
    e.preventDefault()

    let valid = true
    const step13Form = step13Next.closest('.xmas-form')
    const inputFields = step13Form.querySelectorAll('select:not([disabled])')
    inputFields.forEach( inputField => {
      inputField.classList.remove('xmas-error')
        
      if(!inputField.value){
        inputField.classList.add('xmas-error')
        valid = false
      }
    })
    
    if(valid) {
      saveToHistory("q14")
      step14radio.checked = true;
      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      step14radio.dispatchEvent(clickEvent);
      const changeEvent = new Event('change')
      step14radio.dispatchEvent(changeEvent)
      return true;
    }
    
    showModalMessage("Please select an option for each child.")
    return false;
  })

  radioButtons.forEach( radioButton => {
    radioButton.addEventListener('change', () => {
      const allSlides = document.querySelectorAll('.xmas-slide')
      allSlides.forEach( slide => {
        slide.querySelectorAll('input, select').forEach( elem => {
          elem.removeAttribute('tabindex')
        })
      })
        
      const checkedSlide = document.querySelector('input[type="radio"]:checked')
      const checkedSlideID = checkedSlide.getAttribute("id")
      const checkedSlideIndex = checkedSlideID.split("-")[2]  
      const allSlidesExceptTheSelected = document.querySelectorAll('.xmas-slide:not(.xmas-slide[data-index="'+ checkedSlideIndex +'"])')
  
      //console.log(checkedSlide, checkedSlideID, checkedSlideIndex, allSlidesExceptTheSelected)  
      allSlidesExceptTheSelected.forEach( slide => {
        slide.querySelectorAll('input, select').forEach( elem => {
          elem.setAttribute('tabindex',-1)
        }) 
      })
    })
  })

  document.querySelector(".xmas-slider-form ").addEventListener("keydown", function(event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  });


  addButton.addEventListener('click', (e) => {
        
    e.preventDefault()
    showModalMessage('Please wait while we process your answers...')

    //validate all fields

    
    //get items 
    const items = getItemsCart()
    //console.log(items)

    //post it 
    let data = {
      method: "POST",
      headers:{
        'Content-Type':'application/json'
      },
      body: JSON.stringify({
        items: items,
        attributes: {}
      })
    }

    fetch('/cart/add.js', data)
    .then( r => r.json())
    .then( response => {      
      document.location.href = "/checkout"
    })
    .catch(error => {
      console.error("Error: " + error)
    })
    
    //EXTRA: save the whole thing to storage
    
  })  

  let changeEvent2 = new Event('change')
  numberOfChildrenField.dispatchEvent(changeEvent2)

})()